import { Button } from "@/components/ui/button";
import {
  Drawer,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerTrigger,
} from "@/components/ui/drawer";
import { cn } from "@/lib/utils";
import React from "react";
import { SlSettings } from "react-icons/sl";
import { Settings } from "./settings";

interface SettingsPanelProps {
  className?: React.ComponentProps<"div">["className"];
}

const SettingsPanel: React.FC<SettingsPanelProps> = () => {
  return (
    <div className={cn("mr-10 flex md:hidden")}>
      <Drawer>
        <DrawerTrigger asChild>
          <Button>
            <SlSettings />
          </Button>
        </DrawerTrigger>
        <DrawerContent>
          <div className="mx-auto w-full max-w-sm">
            <DrawerHeader>Settings</DrawerHeader>
            <Settings />
          </div>
        </DrawerContent>
      </Drawer>
    </div>
  );
};

export default SettingsPanel;
